/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import Breadcrumb from '../../../component/common/Breadcrumb';
import Duration from '../../../component/common/Duration';
import { XMarkIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { STATUS } from '../../../utils/constants';
import { Api } from '../../../api';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import UploadVideoIcon from '../../../assets/images/video_upload_image.png';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmPopup from '../../../component/common/modals/ConfirmPopup';
import {
  MaxCharlimit,
  MaxCharlimitLongText,
  MaxCharlimitShort,
  errorToast,
  getFileType,
  getLocalStorageItem,
  successToast
} from '../../../utils/helper';
import Loader from '../../../component/common/Loader';
import SecondaryButton from '../../../component/common/Buttons/SecondaryButton';
import axios from 'axios';
import LazyLoadImageProp from '../../../component/common/LazyLoadImage';
import ApprovalHistory from '../../../component/ApprovalHistory/ApprovalHistory';
import Topbar from '../../PulseSurvey/Topbar';
import {
  AddEditGuidanceAudienceValidation,
  AddEditGuidanceContentValidation,
  AddEditGuidanceDetailsValidation,
  AddEditGuidanceValidation
} from '../../../validation/AddEditGuidanceValidation';
import CommonSelect from '../../../component/common/select/CommonSelect';
import InputWithLabel from '../../../component/common/InputWithLabel';
import TextareaWithLabel from '../../../component/common/TextareaWithLabel';
import Icons from '../../../component/svgs/icons';
import { healthVideosPageData as mainPageData } from '../../../utils/pageContent';

const LoadVideo = ({ previewVideo, setMin, setSec }) => {
  const videoEl = useRef(null);

  const handleLoadedMetadata = () => {
    const video = videoEl.current;
    if (!video) return;
    let minutes = Math.floor(video.duration / 60);
    let extraSeconds = video.duration % 60;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let sec = parseInt(extraSeconds);
    sec = sec < 10 ? '0' + sec : sec;
    setMin(minutes);
    setSec(sec);
  };

  function changeSource(url) {
    const video = document.getElementById('video');
    video.src = url;
  }

  useEffect(() => {
    changeSource(previewVideo);
  }, [previewVideo]);

  return (
    <video
      id="video"
      ref={videoEl}
      onLoadedMetadata={handleLoadedMetadata}
      className="m-auto h-[298px] object-center"
      controls
    >
      <source className=" h-[300px]" src={previewVideo} />
    </video>
  );
};

LoadVideo.propTypes = {
  previewVideo: PropTypes.any,
  setSec: PropTypes.any,
  setMin: PropTypes.any
};

export default function AddEditGuidance(props) {
  let location = useLocation();
  let propsData = location?.state;
  const id = new URLSearchParams(window.location.search).get('id');
  const navigate = useNavigate();
  const inputFile2 = useRef(null);
  const guidanceFile = useRef(null);
  const videoRef = useRef(null);
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const [selectedVideo, setSelectedVideo] = useState();
  const [previewVideo, setPreviewVideo] = useState('');
  const [minutes, setMinutes] = useState(0);
  const [minutes2, setMinutes2] = useState(0);
  const [sec, setSec] = useState(0);
  const [sec2, setSec2] = useState(0);
  const [error, setError] = useState({});
  const [categoriesList, setCategoriesList] = useState([]);
  const [selectedFile, setSelectedFile] = useState('');
  const [selectedFile2, setSelectedFile2] = useState('');
  const [selectedFile3, setSelectedFile3] = useState('');
  const [audio, setAudio] = useState('');
  const [bgAudio, setBgAudio] = useState('');
  const [video, setVideo] = useState('');
  const [selectedExpert, setSelectedExpert] = useState('');
  const [previewExpert, setPreviewExpert] = useState('');
  const [selectedGuidance, setSelectedGuidance] = useState('');
  const [previewGuidance, setPreviewGuidance] = useState('');
  const [loader, setLoader] = useState(true);
  const [isView, setIsView] = useState(false);
  const [view, setView] = useState(false);
  const [openConfirmPopupDraft, setOpenConfirmPopupDraft] = useState(false);
  const [openConfirmPopupSave, setOpenConfirmPopupSave] = useState(false);
  const [srtName, setSrtName] = useState(null);
  const [srtUrl, setSrtUrl] = useState(null);
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState({});
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [expertsList, setExpertsList] = useState([]);
  const [expertsLists, setExpertsLists] = useState([]);
  const pagedata = mainPageData.addEditHealthVideosPageData;
  const [selectedType, setSelectedType] = useState(pagedata.pageTypes[0].value);
  const [detailsValid, setDetailsValid] = useState(false);
  const [contentValid, setContentValid] = useState(false);
  const [selectVideoType, setSelectVideoType] = useState([]);
  const [selectedAudience, setSelectedAudience] = useState([]);

  const [pages, setPages] = useState([
    { name: pagedata.addHealthVideoPageTitle, href: '/content-management/health/add-edit' }
  ]);
  const [form, setForm] = useState({
    guidanceId: '',
    guidanceTitle: '',
    description: '',
    guidanceType: 1,
    guidanceBy: 1,
    status: 1,
    video_iframe: '',
    approvalStatus: '',
    expertName: '',
    comments: []
  });

  const handleChangeType = (val) => {
    setSelectedType(val);
  };

  useEffect(() => {
    if (id) {
      setView(true);
    }
  }, [id]);

  const handleChange = (e) => {
    var { name, value } = e.target;
    if (name === 'guidanceTitle' && value !== '') {
      value = value?.slice(0, MaxCharlimit);
      value = value
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
    if (name === 'description' && value !== '') {
      value = value?.slice(0, MaxCharlimitLongText);
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }
    if (name === 'video_iframe' && value !== '') {
      value = value?.slice(0, MaxCharlimitShort);
    }
    const updatedForm = { ...form, [name]: value };
    var updatedError = { ...error, [name]: '' };

    if (name === 'video_iframe' && value !== '') {
      updatedError.guidanceFile = '';
    }
    setError(updatedError);
    if (
      !(name === 'guidanceTitle' && value.length > MaxCharlimit) &&
      !(name === 'description' && value.length > MaxCharlimitLongText) &&
      !(name === 'video_iframe' && value.length > MaxCharlimitShort)
    ) {
      setForm(updatedForm);
    }
  };

  const handleSubmit = (e, fromPopup = false) => {
    e.preventDefault();

    const categorys = categoriesList
      ?.filter((c) => selectedCategory?.find((f) => f?.name === c?.name))
      ?.map((c) => c?._id);

    let tempFocusIdArray = selectedCategory.map((data) => {
      return data?.focuses;
    });

    tempFocusIdArray = [].concat(...tempFocusIdArray)?.filter((data) => data !== null);

    const { isValid, errors } = AddEditGuidanceAudienceValidation(
      form,
      selectedCategory,
      selectVideoType,
      selectedFile2,
      selectedGuidance,
      selected,
      selectedAudience,
      false
    );

    if (isValid) {
      if (propsData && !fromPopup) {
        setOpenConfirmPopupSave(true);
      } else {
        setLoader(true);
        const payload = {
          guidanceId: form.guidanceId,
          guidanceName: form.guidanceTitle,
          guidanceType: form.guidanceType,
          description: form.description,
          audience: selectedAudience?.value,
          isDraft: false,
          guidanceUrl: selectedFile?.type ? getFileType(selectedFile) : '',
          bg_audio: selectedFile3?.type ? getFileType(selectedFile3) : '',
          video_url: selectedFile2?.type ? getFileType(selectedFile2) : '',
          duration:
            minutes2 != null && sec2 != null && (+minutes2 !== 0 || +sec2 !== 0)
              ? `${minutes2}:${sec2}`
              : minutes != null && sec != null && (+minutes !== 0 || +sec !== 0)
                ? `${minutes}:${sec}`
                : minutes != null && sec != null
                  ? `${minutes}:${sec}`
                  : '0:00',
          healthVideoStatus: form.status,
          expertId: selected?.id || '',
          expertName: selected?.id ? selected?.name : ''
        };

        if (form?.guidanceId && form?.approvalStatus !== undefined && form?.approvalStatus !== null) {
          payload['approvalStatus'] = parseInt(form?.approvalStatus);
        } else {
          payload['approvalStatus'] = 1;
        }

        if (form?.guidanceId && categorys?.length > 0) {
          payload['category_ids'] = categorys;
        } else {
          if (!form?.guidanceId && categorys?.length > 0) {
            payload['category_ids'] = categorys;
          }
        }

        if (form?.guidanceId && tempFocusIdArray?.length > 0) {
          payload['focusIds'] = tempFocusIdArray;
        } else {
          if (!form?.guidanceId && tempFocusIdArray?.length > 0) {
            payload['focusIds'] = tempFocusIdArray;
          }
        }

        if (form?.video_iframe) payload['video_iframe'] = form.video_iframe;
        !selectedFile3?.type && delete payload['bg_audio'];
        !selectedFile2?.type && delete payload['video_url'];
        !selectedFile?.type && delete payload['guidanceUrl'];

        if (selectedGuidance?.type) payload['thumbnail_image_url'] = getFileType(selectedGuidance);

        if (form?.guidanceId && selectedFile2) {
          payload['video_iframe'] = '';
        }
        if (form?.guidanceId) {
          if (selectedGuidance?.type)
            payload['thumbnail_image_url'] = getFileType(selectedGuidance);
          else if (previewGuidance === '') payload['thumbnail_image_url'] = '';
        }
        if (form?.guidanceId && form?.video_iframe) {
          payload['video_url'] = '';
        }
        if (form.guidanceId && selectedFile3 === '') {
          payload['bg_audio'] = '';
        }
        if (form.guidanceId && selectedFile === '') {
          payload['guidanceUrl'] = '';
        }

        Api.addGuidance(payload).then(async (response) => {
          if (response?.data?.meta?.code === 1) {
            setLoader(true);
            if (response?.data?.meta?.audioUrl?.uploadURL) {
              setLoader(true);
              await axios.put(response?.data?.meta?.audioUrl?.uploadURL, selectedFile, {
                headers: {
                  'content-type': `${selectedFile?.type?.split('/')[0]}/${selectedFile?.name?.split('.')[1]
                    }`
                }
              });
            }
            if (response?.data?.meta?.videoPreSignUrl?.uploadURL) {
              setLoader(true);
              await axios.put(response?.data?.meta?.videoPreSignUrl?.uploadURL, selectedFile2, {
                headers: {
                  'content-type': `${selectedFile2?.type?.split('/')[0]}/${selectedFile2?.name?.split('.')[1]
                    }`
                }
              });
            }
            if (response?.data?.meta?.thumbnailImageUrl?.uploadURL) {
              setLoader(true);
              await axios.put(
                response?.data?.meta?.thumbnailImageUrl?.uploadURL,
                selectedGuidance,
                {
                  headers: {
                    'content-type': `${selectedGuidance?.type?.split('/')[0]}/${selectedGuidance?.name?.split('.')[1]
                      }`
                  }
                }
              );
            }
            if (response?.data?.meta?.bg_audio?.uploadURL) {
              setLoader(true);
              await axios.put(response?.data?.meta?.bg_audio?.uploadURL, selectedFile3, {
                headers: {
                  'content-type': `${selectedFile3?.type?.split('/')[0]}/${selectedFile3?.name?.split('.')[1]
                    }`
                }
              });
            }
            setLoader(true);
            successToast(response?.data?.meta?.message);
            navigate('/content-management/health', {
              state: { flag: userData?.userType ? 0 : null }
            });
          } else if (response?.data?.meta?.code === 0) {
            setLoader(false);
            errorToast(response?.data?.meta?.message);
          } else {
            setLoader(false);
          }
        });
      }
    } else {
      setError(errors);
    }
  };

  const handleOpen = () => {
    const { isValid, errors } = AddEditGuidanceValidation(
      form,
      selectedCategory,
      selectedFile2,
      selectedGuidance,
      selected,
      true
    );
    if (isValid) {
      setOpenConfirmPopupDraft(true);
    } else {
      setError(errors);
    }
  };

  const handleDraft = (e, fromPopup = false) => {
    e.preventDefault();
    setLoader(true);

    const categorys = categoriesList
      ?.filter((c) => selectedCategory?.find((f) => f?.name === c?.name))
      ?.map((c) => c?._id);

    let tempFocusIdArray = selectedCategory.map((data) => {
      return data?.focuses;
    });

    tempFocusIdArray = [].concat(...tempFocusIdArray)?.filter((data) => data !== null);

    if (!form.guidanceTitle) {
      return errorToast(pagedata.videoNameRequriedMessage);
    }

    if (propsData && !fromPopup) {
      setOpenConfirmPopupDraft(true);
    }

    const payload = {
      guidanceId: form.guidanceId,
      guidanceName: form.guidanceTitle,
      guidanceType: form.guidanceType,
      description: form.description,
      isDraft: true,
      guidanceUrl: selectedFile?.type ? getFileType(selectedFile) : '',
      bg_audio: selectedFile3?.type ? getFileType(selectedFile3) : '',
      video_url: selectedFile2?.type ? getFileType(selectedFile2) : '',
      duration:
        minutes2 != null && sec2 != null && (+minutes2 !== 0 || +sec2 !== 0)
          ? `${minutes2}:${sec2}`
          : minutes != null && sec != null && (+minutes !== 0 || +sec !== 0)
            ? `${minutes}:${sec}`
            : minutes != null && sec != null
              ? `${minutes}:${sec}`
              : '0:00',
      healthVideoStatus: form.status,
      expertId: selected?.id,
      expertName: selected?.name
    };

    if (form?.guidanceId && form?.approvalStatus !== undefined && form?.approvalStatus !== null) {
      payload['approvalStatus'] = parseInt(form?.approvalStatus);
    } else {
      payload['approvalStatus'] = 0;
    }

    if (form?.guidanceId && categorys?.length > 0) {
      payload['category_ids'] = categorys;
    } else {
      if (!form?.guidanceId && categorys?.length > 0) {
        payload['category_ids'] = categorys;
      }
    }

    if (form?.guidanceId && tempFocusIdArray?.length > 0) {
      payload['focusIds'] = tempFocusIdArray;
    } else {
      if (!form?.guidanceId && tempFocusIdArray?.length > 0) {
        payload['focusIds'] = tempFocusIdArray;
      }
    }

    if (form?.video_iframe) payload['video_iframe'] = form.video_iframe;
    !selectedFile3?.type && delete payload['bg_audio'];
    !selectedFile2?.type && delete payload['video_url'];
    !selectedFile?.type && delete payload['guidanceUrl'];

    if (selectedGuidance?.type) payload['thumbnail_image_url'] = getFileType(selectedGuidance);

    if (form?.guidanceId && selectedFile2) {
      payload['video_iframe'] = '';
    }
    if (form?.guidanceId) {
      if (selectedGuidance?.type) payload['thumbnail_image_url'] = getFileType(selectedGuidance);
      else if (previewGuidance === '') payload['thumbnail_image_url'] = '';
    }
    if (form?.guidanceId && form?.video_iframe) {
      payload['video_url'] = '';
    }
    if (form.guidanceId && selectedFile3 === '') {
      payload['bg_audio'] = '';
    }
    if (form.guidanceId && selectedFile === '') {
      payload['guidanceUrl'] = '';
    }

    Api.addGuidance(payload).then(async (response) => {
      if (response?.data?.meta?.code === 1) {
        if (response?.data?.meta?.audioUrl?.uploadURL) {
          setLoader(true);
          await axios.put(response?.data?.meta?.audioUrl?.uploadURL, selectedFile, {
            headers: {
              'content-type': `${selectedFile?.type?.split('/')[0]}/${selectedFile?.name?.split('.')[1]
                }`
            }
          });
        }
        if (response?.data?.meta?.videoPreSignUrl?.uploadURL) {
          setLoader(true);
          await axios.put(response?.data?.meta?.videoPreSignUrl?.uploadURL, selectedFile2, {
            headers: {
              'content-type': `${selectedFile2?.type?.split('/')[0]}/${selectedFile2?.name?.split('.')[1]
                }`
            }
          });
        }
        if (response?.data?.meta?.thumbnailImageUrl?.uploadURL) {
          setLoader(true);
          await axios.put(response?.data?.meta?.thumbnailImageUrl?.uploadURL, selectedGuidance, {
            headers: {
              'content-type': `${selectedGuidance?.type?.split('/')[0]}/${selectedGuidance?.name?.split('.')[1]
                }`
            }
          });
        }
        if (response?.data?.meta?.bg_audio?.uploadURL) {
          setLoader(true);
          await axios.put(response?.data?.meta?.bg_audio?.uploadURL, selectedFile3, {
            headers: {
              'content-type': `${selectedFile3?.type?.split('/')[0]}/${selectedFile3?.name?.split('.')[1]
                }`
            }
          });
        }

        successToast(response?.data?.meta?.message);

        navigate('/content-management/health', {
          state: { flag: userData?.userType ? 0 : null }
        });
      } else if (response?.data?.meta?.code === 0) {
        setLoader(false);
        errorToast(response?.data?.meta?.message);
      } else {
        setLoader(false);
      }
    });

    return;
  };

  const radioHandler = (e) => {
    let { name, value } = e.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: parseInt(value)
    }));
  };

  useEffect(() => {
    Api.getCategoriesById(19).then((res) => {
      setCategoriesList(
        res?.data?.data?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?.name
          };
        })
      );
    });

    Api.getPodExpertsName().then((res) => {
      const expertsData = res?.data?.data?.map((item) => {
        return {
          ...item,
          label: item?.name,
          value: item?.name
        };
      });

      if (!propsData?.id) {
        setLoader(false);
      }
      setExpertsList(expertsData);
      setExpertsLists(expertsData);
    });
  }, []);

  useEffect(() => {
    if ((propsData || id) && categoriesList?.length > 0 && expertsLists?.length > 0) {
      setLoader(true);
      setPages([
        { name: pagedata.mainPageTitle, href: '/content-management/health' },
        {
          name: `${propsData?.action === 'view'
            ? pagedata.viewHealthVideoPageTitle
            : pagedata.editHealthVideoPageTitle
            }`,
          href: `/content-management/health/${propsData?.action === 'view' ? 'view' : 'add-edit'}`
        }
      ]);
      setIsView(propsData?.action === 'view');

      Api.getGuidanceById(id ? id : propsData?.id)
        .then((response) => {
          setLoader(false);
          if (response?.data?.meta?.code === 1) {
            const guidanceData = response?.data?.data;
            setAudio(guidanceData?.guidanceUrl);
            setBgAudio(guidanceData?.bg_audio);
            setVideo(guidanceData?.video_url);
            setSelectedFile(guidanceData?.guidanceUrl);
            setSelectedAudience(
              pagedata.selectedAudienceOptions.find((opt) => opt.value === guidanceData?.audience)
            );
            if (guidanceData?.video_url) {
              setSelectVideoType(pagedata.videoTypeOptions[1]);
              setSelectedVideo(guidanceData?.video_url);
              setSelectedFile2(guidanceData?.video_url);
              setPreviewVideo(guidanceData?.video_url);
            }
            if (guidanceData?.video_iframe) {
              setSelectVideoType(pagedata.videoTypeOptions[0]);
            }
            setSelectedFile3(guidanceData?.bg_audio);
            setSelectedExpert(guidanceData?.expertImage || '');
            setSelectedGuidance(guidanceData?.thumbnail_image_url);
            setPreviewExpert(guidanceData?.expertImage);
            setPreviewGuidance(guidanceData?.thumbnail_image_url);
            setSelected(expertsList?.find((res) => res?.id === guidanceData?.expertId));
            setSelectedCategory(
              categoriesList?.filter((res) => guidanceData?.category_ids?.includes(res?._id)) || []
            );

            const expertName = guidanceData?.expertName
              ? guidanceData.expertName
              : guidanceData?.expertId
                ? expertsList?.find((expert) => expert.id === guidanceData.expertId)?.name
                : '';
            setForm({
              guidanceId: guidanceData?.id,
              guidanceTitle: guidanceData?.display_name || '',
              description: guidanceData?.description || '',
              guidanceType: guidanceData?.guidanceType,
              status: guidanceData?.healthVideoStatus === 3 ? 0 : guidanceData?.healthVideoStatus,
              approvalStatus: guidanceData?.approvalStatus,
              expertName: expertName,
              video_iframe: guidanceData?.video_iframe || '',
              comments: guidanceData?.comments
            });
            const duration = guidanceData?.duration?.split(':');
            if (guidanceData?.video_url) {
              setMinutes2(parseInt(duration[0]));
              setSec2(parseInt(duration[1]));
            } else {
              setMinutes(parseInt(duration[0]));
              setSec(parseInt(duration[1]));
            }
            setSrtUrl(guidanceData?.srtUrl);
            setSrtName(guidanceData?.guidanceSrtName);
          } else if (response?.code === 401) {
            errorToast(response?.message);
          } else if (response?.data?.meta?.code === 0) {
            errorToast(response?.data?.meta?.message);
          }
        })
        .catch((err) => {
          setLoader(false);
        });
    } else {
    }
  }, [propsData, id, categoriesList, expertsLists]);

  useEffect(() => {
    const filteredJobs =
      query === ''
        ? expertsLists
        : expertsLists.filter((job) => job.name.toLowerCase().includes(query.toLowerCase()));
    setExpertsList(filteredJobs);
  }, [query, expertsLists]);

  const handleGuidanceImage = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedExpert(undefined);
      return;
    }
    if (e?.target?.files[0]?.size > 1048576) {
      errorToast(pagedata.fileShouldBeLessThan1MB);
    } else {
      if (e?.target?.files[0]) {
        if (!e?.target?.files[0].name.match(/\.(jpg|jpeg|png|gif)$/i)) {
          errorToast(
            `${pagedata.validImageErrorMessageBeforeFileName} ${e?.target?.files[0].name} ${pagedata.validImageErrorMessageafterFileName}`
          );
        } else {
          setSelectedGuidance(e.target.files[0]);
          const objectUrl = URL.createObjectURL(e.target.files[0]);
          setPreviewGuidance(objectUrl);
          return () => URL.revokeObjectURL(objectUrl);
        }
      } else {
        setPreviewGuidance(undefined);
      }
    }
  };

  const handleVideo = (e) => {
    if (e?.target?.files[0]) {
      if (!e?.target?.files[0].name.match(/\.(mp4|mov|mkv|webm|flv)$/i)) {
        errorToast(pagedata.unsupportedVideoFormatMessage);
      } else {
        setForm({ ...form, video_iframe: '' });
        setError((prev) => ({ ...prev, video_iframe: '', guidanceImage: '' }));
        setSelectedFile2(e.target.files[0]);
        setVideo(URL.createObjectURL(e.target.files[0]));
      }
    }
  };

  const onSelectVideo = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedVideo(undefined);
      return;
    }

    if (e.target.files[0]) {
      if (!e?.target?.files[0].name.match(/\.(avi|mp4|m4v|webm)$/i)) {
        errorToast(
          `${pagedata.validVideoErrorMessageBeforeFileName} ${e?.target?.files[0].name} ${pagedata.validVideoErrorMessageafterFileName}`
        );
      } else if (e?.target?.files[0]?.size > 524288000) {
        errorToast(pagedata.fileShouldBeLessThan500MB);
      } else {
        setSelectedVideo(e.target.files[0]);
        setSelectedFile2(e.target.files[0]);
        const objectUrl = URL.createObjectURL(e.target.files[0]);
        setPreviewVideo(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
      }
    } else {
      setPreviewVideo(undefined);
    }
  };

  const removeFile2 = () => {
    setSelectedFile2('');
    setVideo('');
    setSec2(0);
    setMinutes2(0);
    setPreviewVideo('');
    setSelectedVideo('');
  };

  const handleDetailsSubmit = () => {
    const { isValid, errors } = AddEditGuidanceDetailsValidation(
      form,
      selectedCategory,
      selected,
      false
    );
    if (errors) {
      setError(errors);
    }
    if (isValid === true) {
      setError(errors);
      setSelectedType(pagedata.pageTypes[1].value);
      setDetailsValid(true);
    }
  };

  const handleContentSubmit = () => {
    const { isValid, errors } = AddEditGuidanceContentValidation(
      form,
      selectedGuidance,
      selectVideoType,
      selectedFile2,
      false
    );
    if (errors) {
      setError(errors);
    }
    if (isValid === true) {
      setError(errors);
      setSelectedType(pagedata.pageTypes[2].value);
      setContentValid(true);
    }
  };

  return (
    <div className="relative lg:pl-5">
      {loader && <Loader />}
      <Helmet>
        <meta charSet="utf-8" />
        {propsData?.action === 'view' ? (
          <title>{pagedata.viewHealthVideoMetaTitle}</title>
        ) : propsData?.action === 'edit' ? (
          <title>{pagedata.editHealthVideoMetaTitle}</title>
        ) : (
          <title>{pagedata.addHealthVideoMetaTitle}</title>
        )}
      </Helmet>
      <Topbar
        title={
          propsData?.action === 'view'
            ? pagedata.viewHealthVideoPageTitle
            : propsData?.action === 'edit'
              ? pagedata.editHealthVideoPageTitle
              : pagedata.addHealthVideoPageTitle
        }
      />
      <Breadcrumb pageList={pages} className="lg:mt-8" />

      {/* 3 tabs secction */}
      <div className="sm:flex flex-col md:flex-row mt-5 justify-between nd items-center gap-3">
        <div className="flex items-center h-full md:text-xl font-medium gap-6 text-shoorah-gray9 ">
          <button
            className={
              selectedType === pagedata.pageTypes[0].value ? 'text-black dark:text-white' : ''
            }
            onClick={() => {
              handleChangeType(pagedata.pageTypes[0].value);
            }}
          >
            {pagedata.pageTypes[0].name}
          </button>
          <button
            className={
              selectedType === pagedata.pageTypes[1].value ? 'text-black dark:text-white' : ''
            }
            disabled={!detailsValid && !isView}
            onClick={() => {
              handleChangeType(pagedata.pageTypes[1].value);
            }}
          >
            {pagedata.pageTypes[1].name}
          </button>
          <button
            className={
              selectedType === pagedata.pageTypes[2].value ? 'text-black dark:text-white' : ''
            }
            disabled={!contentValid && !isView}
            onClick={() => {
              handleChangeType(pagedata.pageTypes[2].value);
            }}
          >
            {pagedata.pageTypes[2].name}
          </button>
        </div>
      </div>

      {/* Details Section */}
      {selectedType === pagedata.pageTypes[0].value && (
        <div className="bg-white dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg border-[1.5px] border-shoorah-borderGray dark:border-transparent lg:rounded-2xl rounded-xl md:px-6 lg:py-10 md:py-6 p-4 lg:mt-10 w-full">
          <div className="grid lg:gap-5 gap-4 2xl:gap-10 md:grid-cols-2 2xl:grid-cols-2 grid-cols-1">
            <div className="lg:space-y-6 space-y-4 w-full">
              {/* title text */}
              <InputWithLabel
                label={pagedata.nameLabel}
                placeholder={pagedata.namePlaceholder}
                onChange={handleChange}
                errorMargin="mt-1"
                labelMargin="mb-1"
                errorSize="text-[12px]"
                labelClassName="text-sm text-gray-700 dark:text-shoorah-darkBg"
                value={form.guidanceTitle}
                isLengthValidate={true}
                limit={MaxCharlimit}
                name={'guidanceTitle'}
                id={'guidanceTitle'}
                error={error?.guidanceTitle}
                isRequired={true}
                disabled={isView || view}
              />
              {/* description text area */}
              <TextareaWithLabel
                label={pagedata.descriptionLabel}
                placeholder={pagedata.descriptionPlaceholder}
                onChange={handleChange}
                errorMargin="mt-1"
                labelMargin="mb-1"
                errorSize="text-[12px]"
                className="min-h-[124px]"
                labelClassName="text-sm text-gray-700 dark:text-shoorah-darkBg"
                value={form.description}
                isLengthValidate={true}
                limit={MaxCharlimitLongText}
                name={'description'}
                id={'description'}
                error={error?.description}
                isRequired={true}
                disabled={isView || view}
              />
              {/* radio status select */}
              <div className={`${isView ? 'cursor-default' : 'cursor-pointer'}`}>
                <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                  {pagedata.statusLabel}
                </label>
                <fieldset className="mt-2">
                  <div className="flex space-x-4">
                    {STATUS.map((status, index) => (
                      <div key={index} className="flex items-center">
                        <input
                          id={status.name}
                          name="status"
                          type="radio"
                          value={status.value}
                          onChange={(e) => radioHandler(e)}
                          disabled={isView || view}
                          checked={status.value === form.status || form.status === 3}
                          className="h-5 w-5 border-gray-300 text-shoorah-primary focus:ring-shoorah-primary"
                        />
                        <label
                          htmlFor={status.name}
                          className="ml-3 block text-sm font-medium text-gray-700 dark:text-shoorah-darkBg"
                        >
                          {status.name}
                        </label>
                      </div>
                    ))}
                  </div>
                </fieldset>
              </div>
            </div>
            <div className="lg:space-y-6 space-y-4 w-full">
              {/* Category Select */}
              <div>
                <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                  {pagedata.selectCategoriesLabel}{' '}
                  {!isView && !view && <span className="text-red-400">&#42;</span>}
                </label>
                <CommonSelect
                  name="categories"
                  controlCustomStyle={{ padding: '1px' }}
                  isMulti={true}
                  onChange={(e) => {
                    setSelectedCategory(e);
                    setError((prev) => ({ ...prev, focus: '' }));
                  }}
                  value={selectedCategory}
                  options={categoriesList}
                  disabled={isView || view}
                />
                <span className="text-red-500 text-[12px] mt-1">{error.focus}</span>
              </div>
              <div className={`${isView ? 'cursor-default' : 'cursor-pointer'}`}>
                <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                  {pagedata.selectExpertLabel}{' '}
                  {!isView && !view && <span className="text-red-400">&#42;</span>}
                </label>
                <CommonSelect
                  name="expert"
                  onChange={(e) => {
                    setSelected(e);
                    setError((prev) => ({ ...prev, expertId: '' }));
                  }}
                  value={expertsList?.find((option) => option?.value === selected?.value)}
                  options={expertsList}
                  disabled={isView || view}
                />
                <span className="text-red-500 text-[12px] mt-1">{error.expertId}</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Content Section */}
      {selectedType === pagedata.pageTypes[1].value && (
        <div className="bg-white dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg border-[1.5px] border-shoorah-borderGray dark:border-transparent lg:rounded-2xl rounded-xl md:px-6 lg:py-10 md:py-6 p-4 lg:mt-10 w-full">
          <div className="grid gap-4  md:grid-cols-1 2xl:grid-cols-2 grid-cols-1">
            <div className="lg:space-y-6 space-y-4 w-full">
              {/* thumbnail section */}
              {!isView && (
                <div className="mt-4">
                  <label
                    htmlFor="thumbnail_image_url "
                    className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm"
                  >
                    {pagedata.thumbnailLabel}{' '}
                    {!selectedFile2 && !isView && !view && (
                      <span className="text-red-400">&#42;</span>
                    )}{' '}
                    {pagedata.thumbnailSize}
                  </label>
                  <div className="mt-1">
                    {previewGuidance ? (
                      <>
                        <div className="relative">
                          <div
                            onClick={() => guidanceFile.current.click()}
                            className="h-10 flex items-center justify-between gap-3 w-full rounded-lg px-4 py-[8px] text-sm text-shoorah-lightBlack dark:border-shoorah-darkBgColor dark:text-shoorah-darkBg appearance-none placeholder-gray-400 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor border-[1.5px] border-shoorah-borderGray"
                          >
                            <p className="truncate mr-6">
                              {selectedGuidance?.name
                                ? selectedGuidance?.name
                                : previewGuidance?.split('/')[
                                previewGuidance?.split('/')?.length - 1
                                ]}
                            </p>
                          </div>
                          <input
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            className="hidden"
                            ref={guidanceFile}
                            onChange={(e) => handleGuidanceImage(e)}
                          />

                          <XMarkIcon
                            className="absolute top-1/2 transform -translate-y-1/2 right-[10px] w-[20px] text-red-500 cursor-pointer"
                            onClick={() => {
                              setSelectedGuidance('');
                              setPreviewGuidance('');
                            }}
                          />
                        </div>
                        <div className="mx-auto border rounded-lg mt-2 text-center">
                          <LazyLoadImageProp
                            imageSrc={previewGuidance}
                            className="mx-auto max-h-[250px]"
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png"
                          className="hidden"
                          ref={guidanceFile}
                          onChange={(e) => handleGuidanceImage(e)}
                        />
                        <div
                          onClick={() => guidanceFile.current.click()}
                          className="flex justify-center items-center overflow-hidden rounded-[9px] border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBgColor w-full h-[240px] bg-shoorah-normanGray dark:bg-shoorah-darkBgColor relative"
                        >
                          <div className="flex flex-col justify-center items-center">
                            <Icons.videoUploadIcon className="mb-5 text-shoorah-primary" />
                            <h5 className="text-xs">
                              {pagedata.dropYourImageText}{' '}
                              <span className="text-shoorah-primary font-medium">
                                {pagedata.browseText}
                              </span>
                            </h5>
                            <p className="text-shoorah-gray9 text-[8px] leading-[12px]">
                              {pagedata.imageSupprotFileType}
                            </p>
                          </div>
                        </div>
                        <span className="text-red-500 text-[12px] mt-1">{error.guidanceImage}</span>
                      </>
                    )}
                  </div>
                </div>
              )}
              {(isView || view) && previewGuidance && (
                <div className="mt-4">
                  <label
                    htmlFor="thumbnail_image_url"
                    className="block text-sm font-medium text-gray-700 dark:text-shoorah-darkBg"
                  >
                    {pagedata.thumbnailImageLabel}
                  </label>
                  <div className="mx-auto border rounded-lg mt-2 text-center">
                    <LazyLoadImageProp
                      imageSrc={previewGuidance}
                      className="mx-auto max-h-[250px]"
                    />
                  </div>
                </div>
              )}
              {/*video  type select  section */}
              <div>
                <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                  {pagedata.selectVideoTypeText}{' '}
                  {!isView && !view && <span className="text-red-400">&#42;</span>}
                </label>
                <CommonSelect
                  name="videoType"
                  controlCustomStyle={{ padding: '1px' }}
                  isMulti={false}
                  onChange={(e) => {
                    setSelectVideoType(e);
                    setError((prev) => ({ ...prev, videoType: '' }));
                  }}
                  value={selectVideoType}
                  options={pagedata.videoTypeOptions}
                  disabled={isView || view}
                />
                <span className="text-red-500 text-[12px] mt-1">{error.videoType}</span>
              </div>

              {/* video iframe Video ID section */}
              {selectVideoType === pagedata.videoTypeOptions[0] && (
                <InputWithLabel
                  label={pagedata.videoIDLabel}
                  placeholder={pagedata.videoIDPlaceholder}
                  onChange={handleChange}
                  errorMargin="mt-1"
                  labelMargin="mb-1"
                  errorSize="text-[12px]"
                  labelClassName="text-sm text-gray-700 dark:text-shoorah-darkBg"
                  value={form.video_iframe}
                  name={'video_iframe'}
                  isLengthValidate={true}
                  limit={MaxCharlimitShort}
                  id={'video_iframe'}
                  error={error?.video_iframe}
                  isRequired={true}
                  disabled={isView || view}
                />
              )}

              {/* video file upload section */}
              {selectVideoType === pagedata.videoTypeOptions[1] && (
                <>
                  <input
                    className="hidden"
                    ref={videoRef}
                    onInput={(event) => {
                      onSelectVideo(event);
                      event.target.value = null;
                    }}
                    type="file"
                    accept="video/mp4,video/x-m4v,video/*"
                  />
                  {(selectedVideo || previewVideo) && (
                    <div className="relative">
                      <p className="mb-3">{pagedata.uploadVideoLabel}</p>
                      <div
                        aria-disabled={isView || view}
                        onClick={() => {
                          if (!isView) {
                            videoRef.current.click();
                          }
                        }}
                        className="h-10 flex items-center justify-between gap-3 w-full rounded-lg px-4 py-[8px] text-sm text-shoorah-lightBlack dark:border-shoorah-darkBgColor dark:text-shoorah-darkBg appearance-none placeholder-gray-400 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor border-[1.5px] border-shoorah-borderGray"
                      >
                        <p className="truncate mr-6">
                          {selectedFile2?.name
                            ? selectedFile2?.name
                            : video?.split('/')[video?.split('/')?.length - 1]}
                        </p>
                      </div>
                      <input
                        type="file"
                        className="bg-black hidden"
                        ref={inputFile2}
                        accept="video/*"
                        disabled={isView || view}
                        onChange={(e) => handleVideo(e)}
                        onClick={(event) => {
                          event.target.value = null;
                        }}
                      />

                      {!isView && (
                        <XMarkIcon
                          className="absolute top-[75%] transform -translate-y-1/2 right-[10px] w-[20px] text-red-500 cursor-pointer"
                          onClick={removeFile2}
                        />
                      )}
                    </div>
                  )}
                  {selectedVideo || previewVideo ? (
                    <>
                      {previewVideo && (
                        <div
                          className="relative flex flex-col sm:flex-row md:flex-col lg:flex-row
 gap-6"
                        >
                          <div>
                            {/* <p>{pagedata.uploadVideoLabel}</p> */}
                            <div className="bg-gray-100 mt-4 cursor-pointer h-[300px] border rounded-xl overflow-hidden ">
                              <LoadVideo
                                previewVideo={previewVideo}
                                setMin={setMinutes}
                                setSec={setSec}
                              />
                            </div>
                          </div>
                          <div className="ml-4">
                            <p>{pagedata.durationLabel}</p>
                            <Duration
                              min={minutes}
                              sec={sec}
                              setSec={setSec}
                              setMin={setMinutes}
                              disabled={true}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <p>{pagedata.uploadVideoLabel}</p>
                      <div
                        onClick={() => {
                          videoRef?.current?.click();
                        }}
                        className="border-[3px] border-dashed border-gray-300 rounded-2xl mt-4 cursor-pointer h-[300px] flex justify-center items-center p-3  mx-auto text-center w-full bg-shoorah-normanGray"
                      >
                        <div>
                          <img
                            src={UploadVideoIcon}
                            loading="lazy"
                            className="self-start mx-auto h-[50px] w-[90px]"
                            alt="ArrowUpRight"
                          />
                          <p className="text-sm mt-3 text-passio-grayText ">
                            <span className="text-shoorah-primary font-medium">
                              {pagedata.clickHerText}
                            </span>{' '}
                            {pagedata.uploadOrDropMediaText}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Audience Section */}
      {selectedType === pagedata.pageTypes[2].value && (
        <div className="bg-white dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg border-[1.5px] border-shoorah-borderGray dark:border-transparent lg:rounded-2xl rounded-xl md:px-6 lg:py-10 md:py-6 p-4 lg:mt-10 w-full">
          <p>{pagedata.wherevideosShownQuestionText}</p>
          <div className="grid mt-4 lg:gap-5 gap-4 2xl:gap-10 md:grid-cols-2 2xl:grid-cols-4 grid-cols-1">
            <div>
              <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                {pagedata.selectAudienceText}{' '}
                {!isView && !view && <span className="text-red-400">&#42;</span>}
              </label>
              <CommonSelect
                name="audience"
                controlCustomStyle={{ padding: '1px' }}
                isMulti={false}
                onChange={(e) => {
                  setSelectedAudience(e);
                  setError((prev) => ({ ...prev, audience: '' }));
                }}
                value={selectedAudience}
                options={pagedata.selectedAudienceOptions}
                disabled={isView || view}
              />
              <span className="text-red-500 text-[12px] mt-1">{error.audience}</span>
            </div>
          </div>
        </div>
      )}

      {/* all 3 button section */}

      {!isView && (
        <div className="md:col-span-2 pt-4">
          <div className="lg:space-y-6 space-y-4 w-full flex justify-end">
            <div className="sm:text-right flex gap-x-4 sm:justify-end justify-start">
              <SecondaryButton btnText={pagedata.cancelBtnText} btnType="button" />
              {selectedType === pagedata.pageTypes[0].value && (
                <button
                  onClick={handleDetailsSubmit}
                  className="border border-transparent bg-gradient-to-r from-shoorah-primary to-shoorah-secondary rounded-3xl py-2 sm:py-2 sm:px-5 px-5 text-sm font-medium text-white shadow-sm hover:bg-shoorah-primary focus:outline-none focus:ring-2 focus:ring-shoorah-primary focus:ring-offset-2 flex justify-center items-center gap-2"
                >
                  {pagedata.continueBtnText}
                  <ChevronRightIcon className="w-7 h-7" />
                </button>
              )}
              {selectedType === pagedata.pageTypes[1].value && (
                <button
                  onClick={handleContentSubmit}
                  className="border border-transparent bg-gradient-to-r from-shoorah-primary to-shoorah-secondary rounded-3xl py-2 sm:py-2 sm:px-5 px-5 text-sm font-medium text-white shadow-sm hover:bg-shoorah-primary focus:outline-none focus:ring-2 focus:ring-shoorah-primary focus:ring-offset-2 flex justify-center items-center gap-2"
                >
                  {pagedata.continueBtnText}
                  <ChevronRightIcon className="w-7 h-7" />
                </button>
              )}
              {selectedType === pagedata.pageTypes[2].value && (
                <>
                  <button
                    onClick={handleOpen}
                    id="draft"
                    className={`${false
                      ? 'bg-gray-300'
                      : 'border border-transparent bg-gradient-to-r from-shoorah-primary to-shoorah-secondary'
                      } rounded-3xl py-2 sm:py-3 sm:px-10 px-5 whitespace-nowrap text-sm font-medium text-white shadow-sm hover:bg-shoorah-primary focus:outline-none focus:ring-2 focus:ring-shoorah-primary focus:ring-offset-2`}
                  >
                    {pagedata.saveDraftBtnText}
                  </button>
                  {/* <button className="border border-transparent bg-gradient-to-r from-shoorah-primary to-shoorah-secondary rounded-3xl py-2 sm:py-2 sm:px-5 px-5 text-sm font-medium text-white shadow-sm hover:bg-shoorah-primary focus:outline-none focus:ring-2 focus:ring-shoorah-primary focus:ring-offset-2 flex justify-center items-center gap-2">
                    {pagedata.saveDraftBtnText}
                  </button> */}
                  <button
                    // onClick={handleAudienceSubmit}
                    onClick={handleSubmit}
                    className="border border-transparent bg-gradient-to-r from-shoorah-primary to-shoorah-secondary rounded-3xl py-2 sm:py-3 sm:px-10 px-5 text-sm font-medium text-white shadow-sm hover:bg-shoorah-primary focus:outline-none focus:ring-2 focus:ring-shoorah-primary focus:ring-offset-2 flex justify-center items-center gap-2"
                  >
                    {userData?.userType
                      ? pagedata.submitForApprovalBtnText
                      : pagedata.submitBtnText}
                    <ChevronRightIcon className="w-7 h-7" />
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {isView && form?.comments?.length > 0 && (
        <ApprovalHistory data={form?.comments} title={pagedata.viewTitle} />
      )}
      {openConfirmPopupSave && (
        <ConfirmPopup
          open={openConfirmPopupSave}
          setOpen={setOpenConfirmPopupSave}
          message={pagedata.updateVideoDetailsConfrimMessage}
          setAccepted={(e) => handleSubmit(e, true)}
        />
      )}
      {openConfirmPopupDraft && (
        <ConfirmPopup
          open={openConfirmPopupDraft}
          setOpen={setOpenConfirmPopupDraft}
          message={pagedata.updateVideoDetailsConfrimMessage}
          setAccepted={(e) => handleDraft(e, true)}
        />
      )}
    </div>
  );
}

AddEditGuidance.propTypes = {
  location: PropTypes.any
};
